/**
 *  This truncates the hgvsCdot, for more details check varsome/react_components/packages/varsome/src/js/state/selectors/CardsUI.selectors.js getVariantGeneralInfo.
 *  Input: c.1836_1837insCCCGAATATGAATATGATCTCAAATGGGAGTTTCCAAGAGAAAATTTAGAGTTT
 *  Output c.1836_1837insCC...TT */
export const truncateHgvs = (hgvs) => {
  /**
   * (.*?)ins: matches any characters leading up to and including "ins".
   * ([A-Z]*): matches zero or more uppercase letters (A–Z). Captures the bases sequence in single-letter notation after "ins".
   * (.*): matches any remaining characters until the end of the string. */
  const hgvsParts = hgvs.match(/^(.*?ins)([A-Z]*)(.*)$/);
  if (hgvsParts) {
    const baseSequence = hgvsParts[2];
    if (baseSequence.length < 10) return hgvs;
    const firstTwoBases = baseSequence.slice(0, 2);
    const lastTwoBases = baseSequence.slice(-2);
    return `${hgvsParts[1]}${firstTwoBases}...${lastTwoBases}${hgvsParts[3]} (${baseSequence.length})`;
  }
  return hgvs;
};

/**
 *  This truncates the hgvs_p1 used in Transcripts HGVS Protein column.
 *  Input: I639_Q640insHSRIQALQMVQVTGSSDNEYFYVDFREYEYDLKWEFPRENLEFGKNGMCQMFLQHFFSIGKSLKCTYSPFVFAGKVLGSGAFGKVMNATAYGISKTGVSI
 *  Output I639_Q640insHS...SI(100) */
export const truncateHgvsP1 = (p1) => {
  /**
   * (.*?)ins: matches any characters leading up to and including "ins".
   * ([A-Z]*): matches zero or more uppercase letters (A–Z). Captures the amino acid sequence in single-letter notation after "ins".
   * (.*): matches any remaining characters until the end of the string. */
  const p1Parts = p1.match(/^(.*?ins)([A-Z]*)(.*)$/);
  if (p1Parts) {
    const aminoacidsSequence = p1Parts[2];
    if (aminoacidsSequence.length < 10) return p1;
    const firstTwoAminoAcids = aminoacidsSequence.slice(0, 2);
    const lastTwoAminoAcids = aminoacidsSequence.slice(-2);
    return `${p1Parts[1]}${firstTwoAminoAcids}...${lastTwoAminoAcids}${p1Parts[3]} (${aminoacidsSequence.length})`;
  }
  return p1;
};

/** This truncates the hgvs_p3 used in Transcripts HGVS Protein column and in the General Information component.
 *  Input: p.(Phe612_Gly613insProGluTyrGluTyrAspLeuLysTrpGluPheProArgGluAsnLeuGluPhe)?
 *  Output p.(Phe612_Gly613insPro...Phe)?
 *  Input: p.(Arg595_Glu596insAspGlyAsnGluTyrPheTyrValAspPheArg)
 *  Output p.(Arg595_Glu596insAsp...Arg)
 */
export const truncateHgvsP3 = (p3) => {
  /**
   * (p\.\(.*?ins): matches p.( and any characters leading up to and including "ins".
   * ([A-Z, a-z]*): matches any uppercase (A-Z) or lowercase (a-z) letters and commas (,), zero or more times (*).
   *                Captures the amino acid sequence between the ins part and the closing parenthesis.
   * (\).*?)$: matches a closing parenthesis ) followed by any character zero or more times. */

  const p3Parts = p3.trim().match(/^(p\.\(.*?ins)([A-Z, a-z]*)(\).*?)$/);
  if (p3Parts) {
    const aminoacidsSequence = p3Parts[2];
    const aminoAcidsSequenceLength = aminoacidsSequence.length / 3;
    if (aminoAcidsSequenceLength < 10) return p3;
    const firstAminoAcid = aminoacidsSequence.slice(0, 3);
    const lastAminoAcid = aminoacidsSequence.slice(-3);
    return `${p3Parts[1]}${firstAminoAcid}...${lastAminoAcid}${p3Parts[3]} (${aminoAcidsSequenceLength})`;
  }
  return p3;
};
